<template>
	<div id="qs_left2">
		<div class="cc-header">活动情况</div>
		<div class="active_title">活动分布</div>
		<dv-decoration-3 :color="['#55ffff', '#ffaa00']" style="width:200px;height:0.1rem;margin: 0 auto;" />
		<div class="main-value" id="active_course"></div>
		<div class="active_title">人均活动次数</div>
		<dv-decoration-3 :color="['#aaaaff', '#55ff00']" style="width:200px;height:0.1rem;margin: 0 auto;" />
		<div class="main-value" id="active_num"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
let pageSize = 9; //echarts每页显示数量
let activityCountByTypeChart;
export default {
	data() {
		return {
			start: 0,
			end: pageSize - 1,
			total: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		this.interval1 = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
		// 定时器轮播，5秒
		this.interval2 = setInterval(() => {
			_this.dataZoomAutoScoll();
		}, 1000 * 5);
	},
	beforeDestroy() {
		clearInterval(this.interval1);
		clearInterval(this.interval2);
	},
	methods: {
		//echarts图标数据过多时，x轴自动滑动
		dataZoomAutoScoll() {
			const max = this.total - 1;
			if (pageSize < this.total) {
				if (this.end > max || this.start > max - pageSize) {
					this.start = 0;
					this.end = pageSize - 1;
				} else {
					this.start += 1;
					this.end += 1;
				}
				activityCountByTypeChart.dispatchAction({
					type: 'dataZoom',
					dataZoomIndex: 0,
					startValue: this.start,
					endValue: this.end
				});
			}
		},
		initData() {
			// 基于准备好的dom，初始化echarts实例
			activityCountByTypeChart = echarts.init(document.getElementById("active_course"));
			this.$http.get("/dataView/quality/getActivityCountByType?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					var option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							},
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '</b>个';
								}
								return relVal
							}
						},
						xAxis: {
							type: 'value',
							boundaryGap: true,
							axisLabel: {
								interval: 0,
								textStyle: {
									color: '#86c7ff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							},
							axisTick: {
								show: true
							},
							splitLine: {
								show: false
							}
						},
						grid: {
							x: 70,
							top: "10%",
							bottom: "25%"
						},
						yAxis: {
							type: 'category',
							data: result.xDatas,
							splitLine: {
								show: false,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#86c7ff',
									fontSize: fontSize(0.15)
								}
							},
							axisLine: {
								show: true
							},
							axisTick: {
								show: true
							}
						},
						series: [{
							name: '活动数量',
							type: 'bar',
							data: result.ydatas,
							label: {
								normal: {
									show: true,
									position: 'right',
									offset: [5, -2],
									textStyle: {
										color: '#55ffff',
										fontSize: 13
									}
								}
							},
							itemStyle: {
								//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
								normal: {
									//柱形图圆角，初始化效果
									barBorderRadius: [50],
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: "#00ffff" // 0% 处的颜色
									}, {
										offset: 1,
										color: "#a5ff3e" // 100% 处的颜色
									}], false)
								}
							},
							barGap: '0%',
							barWidth: 8
						}]
					};
					activityCountByTypeChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => activityCountByTypeChart.resize(), false);
				}
			});
			let _this = this;
			// 漏斗样式开始
			let myChartPieBottom = echarts.init(
				document.getElementById("active_num")
			);
			this.$http.get("/dataView/quality/getAverageCountByGrade?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.total = result.xDatas.length;
					var option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							},
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '</b>次';
								}
								return relVal
							}
						},
						dataZoom: [{
							type: 'inside',
							startValue: _this.start,
							endValue: _this.end,
						}],
						xAxis: {
							type: 'category',
							data: result.xDatas,
							axisLabel: {
								interval: 0,
								rotate: 40,
								textStyle: {
									color: '#aaaaff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							},
							axisTick: {
								show: true
							},
							splitLine: {
								show: false
							}
						},
						yAxis: {
							type: 'value',
							splitLine: {
								show: false,
								lineStyle: {
									width: 10,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#aaaaff',
									fontSize: fontSize(0.15)
								}
							},
							axisLine: {
								show: true
							},
							axisTick: {
								show: true
							}
						},
						series: [{
							name: '人均次数',
							data: result.ydatas,
							type: 'bar',
							itemStyle: {
								//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
								normal: {
									//柱形图圆角，初始化效果
									barBorderRadius: [10],
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: "#9c6aff" // 0% 处的颜色
									}, {
										offset: 1,
										color: "#3e8bff" // 100% 处的颜色
									}], false)
								}
							},
							barGap: '0%',
							barWidth: 12
						}]
					};
					myChartPieBottom.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => myChartPieBottom.resize(), false);
				}

			});
			// 漏斗样式结束
		}
	},
	destroyed() {
		window.onresize = null;
	}
};


function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#qs_left2 {
	height: 100%;
	padding: 0 5%;

	.cc-header {
		width: 100%;
		padding-top: 1%;
		color: #55ffff;
		font-size: 0.3rem;
		display: flex;
		align-items: center;
		position: relative;
	}

	.active_title {
		text-align: center;
		font-size: 0.25rem;
		letter-spacing: 4px;
		color: #d3d6ff;
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {
		.cc-header {
			height: 15%;
			padding-left: 3%;
		}

		.main-value {
			height: 45%;
		}
	}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {
		.cc-header {
			height: 10%;
		}

		.main-value {
			height: 40%;
		}
	}
}
</style>
